import { render, staticRenderFns } from "./InviteProfile.vue?vue&type=template&id=f0aac872&scoped=true&"
import script from "./InviteProfile.vue?vue&type=script&lang=js&"
export * from "./InviteProfile.vue?vue&type=script&lang=js&"
import style0 from "./InviteProfile.vue?vue&type=style&index=0&id=f0aac872&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aac872",
  null
  
)

export default component.exports